/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_PaxInputs */

const en_shared_pax = /** @type {(inputs: Shared_PaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pax`)
};

const nl_shared_pax = /** @type {(inputs: Shared_PaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pax`)
};

/** @type {(inputs: Shared_PaxInputs) => LocalizedString} */
const de_shared_pax = en_shared_pax;

/** @type {(inputs: Shared_PaxInputs) => LocalizedString} */
const es_shared_pax = en_shared_pax;

/** @type {(inputs: Shared_PaxInputs) => LocalizedString} */
const fr_shared_pax = en_shared_pax;

/** @type {(inputs: Shared_PaxInputs) => LocalizedString} */
const it_shared_pax = en_shared_pax;

/** @type {(inputs: Shared_PaxInputs) => LocalizedString} */
const pt_br2_shared_pax = en_shared_pax;

/** @type {(inputs: Shared_PaxInputs) => LocalizedString} */
const pl_shared_pax = en_shared_pax;

/** @type {(inputs: Shared_PaxInputs) => LocalizedString} */
const hu_shared_pax = en_shared_pax;

/** @type {(inputs: Shared_PaxInputs) => LocalizedString} */
const ro_shared_pax = en_shared_pax;

/**
* | output |
* | --- |
* | "pax" |
*
* @param {Shared_PaxInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_pax = /** @type {((inputs?: Shared_PaxInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_PaxInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_pax(inputs)
	if (locale === "de") return de_shared_pax(inputs)
	if (locale === "es") return es_shared_pax(inputs)
	if (locale === "fr") return fr_shared_pax(inputs)
	if (locale === "nl") return nl_shared_pax(inputs)
	if (locale === "it") return it_shared_pax(inputs)
	if (locale === "pt-BR") return pt_br2_shared_pax(inputs)
	if (locale === "pl") return pl_shared_pax(inputs)
	if (locale === "hu") return hu_shared_pax(inputs)
	return ro_shared_pax(inputs)
});
export { shared_pax as "shared.pax" }